import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Balloon } from '@alifd/next';
import { getText } from 'src/utils/i18n';
import globalDataStore from 'src/utils/global-data-store';
import './index.scss';

function getI18nMap(i18n) {
  const SERVICES_MAP = {
    logistic: {
      text: getText(i18n, 'details_services.logistic', 'Alibaba.com Logistics'),
      tipTexts: [
        getText(
          i18n,
          'details_services.logisticTip1',
          'Fast ocean and air shipping',
        ),
        getText(i18n, 'details_services.logisticTip2', 'Competitive prices'),
        getText(i18n, 'details_services.logisticTip3', 'Online tracking'),
      ],
      link: 'https://ship.alibaba.com',
    },
    inspection: {
      text: getText(
        i18n,
        'details_services.inspection',
        'Inspection Solutions',
      ),
      tipTexts: [
        getText(
          i18n,
          'details_services.inspectionTip1',
          'Leading inspection companies',
        ),
        getText(i18n, 'details_services.inspectionTip2', 'Competitive pricing'),
        getText(
          i18n,
          'details_services.inspectionTip3',
          'Dedicated one-on-one service',
        ),
      ],
      link: 'https://inspection.alibaba.com',
    },
    PRODUCE_VISUALIZATION_PRODUCT: {
      text: getText(i18n, 'details_services.productionview', 'Production View'),
      tipTexts: [
        getText(
          i18n,
          'details_services.productionview.tip',
          'Track the production process of your order.',
        ),
      ],
      link: 'https://activity.alibaba.com/onetouch/production-view.html',
    },
    EC_INTEGRATION_PRODUCT: {
      text: getText(i18n, 'details_services.onestop', 'One-Stop Service'),
      tipTexts: [
        getText(
          i18n,
          'details_services.onestop.tip',
          'Fulfillment service for your dropshipping business. Customization, packaging and labeling and more.',
        ),
      ],
      link: 'https://activity.alibaba.com/onetouch/one-stop-service.html',
    },
    pt: {
      text: getText(i18n, 'details_services.pt', 'Payment Terms: Net-60'),
      tipTexts: [
        getText(
          i18n,
          'companyCardIntegrated.pt.balloon',
          'This supplier accepts Alibaba.com Payment Terms, giving you up to 60 days to pay for orders. ',
        ),
      ],
      link: '//paylater.alibaba.com/page/PAYMENT_TERMS/expo?tracelog=details',
    },
  };

  return SERVICES_MAP;
}

class Services extends React.Component {
  static propTypes = {
    productId: PropTypes.number,
    i18n: PropTypes.object,
    companyRegisterCountry: PropTypes.string,
    supplyChainService: PropTypes.arrayOf(PropTypes.string),
    baoAccountIsDisplayAssurance: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      keys: ['logistic', 'inspection'],
      showPT: false,
    };
  }

  componentDidMount() {
    // const { productId } = this.props;
    const fetchPromise = globalDataStore.get('supplierData');
    if (fetchPromise) {
      fetchPromise.then(data => {
        if (!data || !data.isSuccess || !data.result) {
          return;
        }
        if (data.result.supplierOnCredit) {
          this.setState({
            ...this.state,
            showPT: true,
          });
        }
      });
    }
  }

  render() {
    const { props } = this;
    const {
      i18n,
      companyRegisterCountry,
      supplyChainService,
      baoAccountIsDisplayAssurance,
    } = props;

    const isUS = companyRegisterCountry === 'US';

    let keys = this.state.keys.concat(supplyChainService || []);
    if (isUS || !baoAccountIsDisplayAssurance) {
      keys = [];
    }
    if (this.state.showPT) {
      keys.push('pt');
    }

    const SERVICES_MAP = getI18nMap(i18n);

    return (
      <div className="details-services">
        {keys.map((name, index) => {
          const elService = (
            <span
              key={index}
              className={classNames({
                'service-item': true,
                'is-pt-item': name === 'pt' && keys.length > 4,
              })}
            >
              <span className="service-name">{SERVICES_MAP[name].text}</span>
            </span>
          );
          return (
            <Balloon
              className="details-services-balloon"
              trigger={elService}
              align="br"
              closable={false}
              key={name}
            >
              <ul
                className={classNames({
                  'tip-text': true,
                  multiline: SERVICES_MAP[name].tipTexts.length > 1,
                })}
              >
                {SERVICES_MAP[name].tipTexts.map((text, _i) => (
                  <li className="text-item" key={_i}>
                    {text}
                  </li>
                ))}
              </ul>
              <div className="tip-link">
                <a href={SERVICES_MAP[name].link} target="_blank">
                  {getText(
                    i18n,
                    'details_assurance_educate.learnmore',
                    'Learn More',
                  )}
                </a>
              </div>
            </Balloon>
          );
        })}
      </div>
    );
  }
}

export default Services;
